import { compose } from 'redux';
import { WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';
import { WithFetchDatasByParamsFromCMS } from 'modules/shared-cms-advanced';
import {
    WithNotifyRessourceLoaded,
    WithSessionStorage,
    WithRemoteActions,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { SessionName, Session } from 'modules/mariage/models';
import { appointmentService } from 'modules/mariage/services/appointment-service';
import { readPageTitle } from 'modules/shared-cms/utils';
import { QUERY } from './manage-appointment-query';
import { ManageAppointmentLoader } from './manage-appointment-loader';
import { ManageAppointmentRemoteActionsProps } from './manage-appointment-type';

const defaultErrorMessage =
    'Nous rencontrons un problème avec le service de prise de rendez-vous. Merci de réessayer un peu plus tard.';

const enhancer = compose<
    React.ComponentType<WithFetchDatasByIdFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByParamsFromCMS(ManageAppointmentLoader, QUERY, 'queryLandingAppointmentContents'),
    WithNotifyRessourceLoaded(readPageTitle),
    WithSessionStorage<Session>(SessionName),
    WithRemoteActions<ManageAppointmentRemoteActionsProps>({
        getAppointment: {
            action: appointmentService.getAppointment,
            errorMessages: [
                {
                    code: 40.18,
                    message: 'Aucun rendez-vous ne correspond à cette référence.',
                },
            ],
            defaultErrorMessage,
        },
        getAppointments: {
            action: appointmentService.getAppointments,
            defaultErrorMessage,
        },
        getCustomer: {
            action: appointmentService.getCustomer,
            defaultErrorMessage,
        },
        deleteAppointment: {
            action: appointmentService.deleteAppointment,
            defaultErrorMessage,
        },
        requestRef: {
            action: appointmentService.requestAppointmentRef,
            defaultErrorMessage,
        },
    }),
);
export default enhancer;
